import type { MessageKey } from "./en";

/** Serbian (Latin script). Must define exactly the keys of `en`; the type and a test enforce it. */
export const sr: Record<MessageKey, string> = {
  "admin.invites.col.link": "Link",
  "admin.tabs.invites": "Pozivnice",
  "admin.pendingInvite": "Pozivnica za {email}",
  "admin.invites.title": "Pozivnice",
  "admin.requests.title": "Zahtevi za pozivnice",
  "admin.requests.empty": "Nema zahteva za pozivnice.",
  "admin.requests.col.team": "Tim",
  "admin.requests.col.message": "Poruka",
  "admin.requests.col.received": "Primljeno",
  "admin.requests.showMessage": "Prikaži celu poruku",
  "admin.requests.hideMessage": "Sakrij poruku",
  "admin.requests.noMessage": "Bez poruke",
  "admin.requests.createInvite": "Napravi pozivnicu",
  "admin.requests.dismiss": "Odbaci",
  "admin.requests.dismissTitle": "Odbaci zahtev",
  "admin.requests.dismissMessage":
    "Odbaciti zahtev od {email}? Uklanja se sa liste i pozivnica se ne šalje.",
  "admin.requests.countLabel": "{count} novih zahteva za pozivnice",
  "admin.invites.empty": "Još nema pozivnica.",
  "admin.invites.col.expires": "Ističe",
  "admin.invites.status.pending": "Na čekanju",
  "admin.invites.status.opened": "Otvorena",
  "admin.invites.status.used": "Iskorišćena",
  "admin.invites.status.expired": "Istekla",
  "admin.invites.status.revoked": "Opozvana",
  "admin.invites.linkUnavailable": "Link nije dostupan. Napravite novi.",
  "admin.invites.resend": "Pošalji ponovo",
  "admin.invites.newLink": "Novi link",
  "admin.invites.revoke": "Opozovi",
  "admin.invites.newLinkTitle": "Novi link",
  "admin.invites.newLinkMessage":
    "Napraviti novi link za {email}? Stari link odmah prestaje da radi.",
  "admin.invites.revokeTitle": "Opozovi pozivnicu",
  "admin.invites.revokeMessage": "Opozvati pozivnicu za {email}? Njen link odmah prestaje da radi.",
  "roster.invite": "Pozovi igrača",
  "roster.inviteTitle": "Pozovi igrača",
  "roster.inviteSubmit": "Napravi link za poziv",
  "roster.linkCreate": "Napravi link",
  "roster.linkUnavailable": "Link nije dostupan. Napravite novi.",
  "roster.opened": "Otvoren {when}",
  "roster.notOpened": "Nije otvoren",
  "roster.songChosen": "Pesma izabrana",
  "roster.qr": "QR",
  "roster.shareLink": "Podeli link",
  "roster.moreActions": "Još radnji za {name}",
  "roster.lockSong": "Zaključaj pesmu",
  "roster.unlockSong": "Otključaj pesmu",
  "roster.regenerate": "Napravi novi link",
  "roster.statusLocked": "Zaključano",
  "roster.statusOpened": "Link otvoren",
  "roster.statusNoLink": "Nema linka",
  "roster.deletedOn": "Obrisano {date}",
  "roster.tryAgain": "Pokušaj ponovo",
  "link.intro": "Podelite ovaj link sa osobom {name}.",
  "link.regenerated": "Prethodni link više ne radi.",
  "invitePage.for": "Poziv za {email} u {workspace}",
  "invitePage.noWorkspace": "radni prostor",
  "invitePage.invalidTitle": "Ovaj poziv nije moguće koristiti",
  "invitePage.invalidText": "Zamolite osobu koja vas je pozvala za novi link.",

  "app.name": "Goalhorns Online",
  "app.loading": "Učitavanje…",
  "app.retry": "Pokušaj ponovo",

  "common.save": "Sačuvaj",
  "common.cancel": "Otkaži",
  "common.close": "Zatvori",
  "common.delete": "Obriši",
  "common.restore": "Vrati",
  "common.edit": "Izmeni",
  "common.copy": "Kopiraj",
  "common.copied": "Kopirano",
  "common.share": "Podeli",
  "common.add": "Dodaj",
  "common.remove": "Ukloni",
  "common.rename": "Preimenuj",
  "common.duplicate": "Dupliraj",
  "common.open": "Otvori",
  "common.create": "Napravi",
  "common.confirm": "Potvrdi",
  "common.none": "Nema",
  "common.active": "Aktivan",
  "common.inactive": "Neaktivan",
  "common.locked": "Zaključano",
  "common.unlocked": "Otključano",
  "common.deleted": "Obrisano",
  "common.filterActive": "Aktivno",
  "common.filterDeleted": "Obrisano",
  "common.role.owner": "Vlasnik",
  "common.role.member": "Član",

  "auth.login.title": "Prijava",
  "auth.login.subtitle": "Upravljajte spiskovima, konfiguracijama i izvozima.",
  "auth.login.google": "Prijavi se preko Google-a",
  "auth.login.inviteNote": "Pozvani ste. Prijavite se adresom e-pošte na koju je poziv poslat.",
  "auth.dev.title": "Razvojna prijava",
  "auth.dev.email": "E-pošta",
  "auth.dev.submit": "Prijavi se kao ova e-pošta",
  "auth.invite.title": "Prihvatite pozivnicu",
  "auth.invite.text": "Prijavite se adresom e-pošte na koju je pozivnica poslata.",
  "auth.error.oauth_state_invalid": "Prijava je istekla ili je prekinuta. Pokušajte ponovo.",
  "auth.error.email_unverified": "Vaša Google adresa e-pošte nije potvrđena.",
  "auth.error.not_invited": "Ovaj nalog nije pozvan u Goalhorns.",
  "auth.error.invite_invalid": "Ovaj poziv je istekao, već je iskorišćen ili opozvan.",
  "auth.error.invite_email_mismatch": "Ovaj poziv je izdat za drugu adresu e-pošte.",
  "auth.error.oauth_not_configured": "Prijava preko Google-a nije podešena.",
  "auth.error.oauth_exchange_failed": "Prijava preko Google-a nije uspela. Pokušajte ponovo.",
  "auth.error.rate_limited": "Previše pokušaja prijave. Sačekajte minut pa pokušajte ponovo.",
  "auth.error.unknown": "Prijava nije uspela, pokušajte ponovo.",

  "nav.roster": "Spisak",
  "nav.configurations": "Konfiguracije",
  "nav.members": "Članovi",
  "nav.usage": "Korišćenje",
  "nav.desktops": "Računari",
  "nav.label": "Odeljci radnog prostora",

  "workspace.switch": "Radni prostor",
  "workspace.recent": "Nedavni radni prostori",
  "workspace.none": "Još nema radnog prostora",
  "workspace.noneText": "Otvorite radni prostor po njegovom ID-u ili prihvatite pozivnicu.",
  "workspace.idLabel": "ID radnog prostora",
  "workspace.open": "Otvori radni prostor",
  "workspace.acting": "Delujete kao radni prostor {name}. Svaka radnja se beleži.",
  "workspace.stopActing": "Prestani da delujem",
  "workspace.missing": "Ovaj radni prostor ne postoji ili vaš nalog nema pristup njemu.",
  "workspace.backToList": "Nazad na vaše radne prostore",
  "workspace.yours": "Vaši radni prostori",
  "workspace.openRow": "Otvori",
  "common.role.admin": "Admin",

  "user.menu": "Nalog",
  "user.signOut": "Odjavi se",
  "lang.label": "Jezik",
  "lang.en": "EN",
  "lang.rs": "RS",
  "lang.ru": "RU",

  "roster.title": "Spisak",
  "roster.add": "Dodaj osobu",
  "roster.empty": "Na spisku još nema nikoga.",
  "roster.emptyDeleted": "Nema obrisanih osoba.",
  "roster.changed": "Izmenjeno",
  "roster.photoLocked": "Fotografija zaključana",
  "roster.noPhoto": "Nema fotografije",
  "roster.noSong": "Još nema pesme",
  "roster.number": "Br. {number}",
  "roster.noNumber": "Bez broja",
  "roster.region": "Region {region}",
  "roster.newLink": "Novi link",
  "roster.uploadPhoto": "Otpremi fotografiju",
  "roster.replacePhoto": "Zameni fotografiju",
  "roster.lockPhoto": "Zaključaj fotografiju",
  "roster.unlockPhoto": "Otključaj fotografiju",
  "roster.songLocked": "Pesma zaključana",
  "roster.songUnlocked": "Pesma otključana",
  "roster.confirmDelete": "Obrisati {name}? Možete je vratiti u roku od 30 dana.",
  "roster.confirmRegenerate": "Napraviti novi link za {name}? Stari link prestaje odmah da radi.",
  "roster.photoTooLarge": "Fotografija je veća od 5 MB.",
  "roster.photoType": "Koristite PNG ili JPEG fotografiju.",
  "roster.uploading": "Otpremanje fotografije",

  "person.addTitle": "Dodaj osobu",
  "person.editTitle": "Izmeni osobu",
  "person.name": "Ime",
  "person.number": "Broj",
  "person.numberHint": "Opciono, od 0 do 999.",
  "person.invalidName": "Unesite ime do 80 znakova.",
  "person.invalidNumber": "Broj mora biti ceo broj od 0 do 999.",

  "link.title": "Link za igrača",
  "link.share": "Podeli",
  "link.qrLabel": "QR kod za link ovog igrača",
  "link.shareUnsupported": "Deljenje nije dostupno u ovom pregledaču. Koristite Kopiraj.",

  "configs.title": "Konfiguracije",
  "configs.create": "Nova konfiguracija",
  "configs.nameLabel": "Naziv",
  "configs.namePlaceholder": "Naziv konfiguracije",
  "configs.empty": "Još nema konfiguracija.",
  "configs.emptyDeleted": "Nema obrisanih konfiguracija.",
  "configs.changedSince": "{count} izmenjeno od poslednjeg preuzimanja",
  "configs.neverDownloaded": "Nikad nije preuzeto",
  "configs.lockSwitch": "Otključano",
  "configs.unlockSwitch": "Zaključaj ili otključaj {name}",
  "configs.rename": "Preimenuj konfiguraciju",
  "configs.confirmDelete": "Obrisati {name}? Možete je vratiti u roku od 30 dana.",
  "configs.createSubmit": "Kreiraj",
  "configs.lockForGame": "Zaključaj za utakmicu",
  "configs.unlock": "Otključaj",
  "configs.open": "Otvoreno",
  "configs.openLineup": "Otvori postavu",
  "configs.players": "igrača",
  "configs.downloadedAt": "Preuzeto {when}",
  "configs.more": "Još radnji za {name}",

  "editor.back": "Sve konfiguracije",
  "editor.addPerson": "Dodaj u konfiguraciju",
  "editor.pickPerson": "Izaberite osobu",
  "editor.noAvailable": "Svi sa spiska su već u ovoj postavi.",
  "editor.empty": "Ova konfiguracija još nema slotova.",
  "editor.save": "Sačuvaj slotove",
  "editor.discard": "Odbaci izmene",
  "editor.saved": "Slotovi su sačuvani.",
  "editor.dirty": "Nesačuvane izmene",
  "editor.locked": "Ova konfiguracija je zaključana. Otključajte je da biste menjali slotove.",
  "editor.changedList": "Izmenjeno od poslednjeg preuzimanja",
  "editor.changedSummary": "{count} igrača izmenjeno od poslednjeg preuzimanja",
  "editor.changedNone": "Ništa nije izmenjeno od poslednjeg preuzimanja.",
  "editor.dragHandle": "Prevucite za promenu redosleda",
  "editor.slot": "Slot {position}",
  "editor.activeLabel": "Aktivan",
  "editor.hotkey": "Prečica",
  "editor.hotkeyNone": "Nema prečice",
  "editor.setHotkey": "Postavi prečicu",
  "editor.changeHotkey": "Promeni",
  "editor.hotkeyClear": "Obriši",
  "editor.clearHotkey": "Obriši prečicu za {name}",
  "editor.hotkeyPress": "Pritisnite tastere…",
  "editor.hotkeyHint":
    "Držite tastere, pa ih otpustite sve da biste sačuvali. Samo Esc otkazuje. Sami modifikatori se ignorišu.",
  "editor.hotkeyIgnored": "Prečica mora imati taster koji nije modifikator.",
  "editor.hotkeyLocal": "Sukob prečice u ovoj konfiguraciji",
  "editor.hotkeyReservedLocal": "Ova prečica je rezervisana za desktop aplikaciju",
  "editor.hotkeyDuplicateLocal": "Drugi slot već koristi ovu prečicu",
  "editor.slotsErrorTitle": "Server nije sačuvao slotove",
  "editor.removeConfirm": "Ukloniti {name} iz ove konfiguracije?",
  "editor.lockedBand": "ZAKLJUČANO — igrači ne mogu da menjaju pesme",
  "editor.bench": "Klupa",
  "editor.addPlayers": "Dodaj igrače",
  "editor.searchPlayers": "Pretraga igrača",
  "editor.addPlayer": "Dodaj {name}",
  "editor.noMatches": "Nijedan igrač ne odgovara pretrazi.",
  "editor.removeFromLineup": "Ukloni {name} iz postave. Ostaje na spisku.",

  "export.button": "Preuzmi .goalhorns",
  "export.preparing": "Priprema paketa…",
  "export.progress": "Dodavanje medija {done} od {total}",
  "export.marking": "Beleženje preuzimanja…",
  "export.done": "Preuzeto: {name}.",
  "export.cancelled": "Preuzimanje je otkazano.",
  "export.noMedia": "Nema medija za dodavanje.",
  "export.building": "Pravim .goalhorns… {percent}%",

  "members.title": "Članovi",
  "members.ownerOnly": "Samo vlasnik radnog prostora može da upravlja članovima.",
  "members.invite": "Pozovite saradnika",
  "members.email": "E-pošta",
  "members.role": "Uloga",
  "members.inviteButton": "Pošalji pozivnicu",
  "members.inviteOnce":
    "Pošaljite ovaj link pozvanoj osobi. Prikazuje se samo jednom i ne može se ponovo prikazati.",
  "members.pending": "Pozivnice na čekanju",
  "members.noPending": "Nema pozivnica na čekanju.",
  "members.makeOwner": "Postani vlasnik",
  "members.makeMember": "Postani član",
  "members.moreActions": "Još radnji za {name}",
  "members.inviteStatusPending": "Na čekanju",
  "members.inviteStatusExpired": "Istekla",
  "members.resend": "Pošalji ponovo",
  "members.confirmRevokeTitle": "Poništi pozivnicu",
  "members.confirmRevoke": "Poništiti pozivnicu za {email}? Link više neće raditi.",
  "members.expires": "Ističe {date}",
  "members.revoke": "Poništi",
  "members.roster": "Osobe sa pristupom",
  "members.you": "Vi",
  "members.confirmRemove": "Ukloniti {name} iz ovog radnog prostora?",
  "members.ownerProtected": "Vlasnik",

  "usage.title": "Korišćenje",
  "usage.bytes": "Skladište",
  "usage.persons": "Osobe",
  "usage.configurations": "Konfiguracije",
  "usage.of": "{used} od {quota}",
  "usage.noQuota": "{used} u upotrebi (bez kvote)",
  "usage.unitPeople": "igrača",
  "usage.nearLimit": "Blizu granice. Oslobodite prostor pre novih dodavanja.",

  "keys.title": "API ključevi",
  "keys.note":
    "Sync API za desktop aplikaciju dolazi kasnije. Ključevi su samo za buduću sinhronizaciju.",
  "keys.label": "Oznaka",
  "keys.create": "Napravi ključ",
  "keys.createdOnce":
    "Kopirajte ovaj ključ odmah. Prikazuje se samo jednom i ne može se ponovo prikazati.",
  "keys.empty": "Nema ključeva za ovu konfiguraciju.",
  "keys.wontSeeAgain":
    "Nećete ponovo videti ovaj ključ. Kopirajte ga sada i sačuvajte na sigurnom mestu.",
  "keys.submit": "Napravi",
  "keys.dialogTitle": "Novi API ključ",
  "keys.active": "Aktivan",
  "keys.revokedGroup": "Opozvani ({count})",
  "keys.moreActions": "Još radnji za {name}",
  "keys.revokeTitle": "Opozovi ključ",
  "keys.confirmRevoke":
    "Opozvati {name}? Sve što koristi ovaj ključ prestaće da radi. Ovo se ne može poništiti.",
  "keys.done": "Gotovo",
  "keys.revoke": "Opozovi",
  "keys.revoked": "Opozvano",
  "keys.lastUsed": "Poslednji put korišćeno {date}",
  "keys.never": "Nikad korišćeno",
  "keys.created": "Napravljeno {date}",

  "devices.title": "Računari",
  "devices.intro": "Poveži desktop aplikaciju Goalhorns sa ovim radnim prostorom.",
  "devices.linkButton": "Poveži računar",
  "devices.codeTitle": "Kod za povezivanje",
  "devices.codeSteps": "U desktop aplikaciji otvori Konfiguracije → Online i unesi ovaj kod.",
  "devices.codeReady": "Kod je spreman. Unesi ga u desktop aplikaciju.",
  "devices.codeExpired": "Kod je istekao.",
  "devices.countdown": "Kod ističe za {time}",
  "devices.newCode": "Novi kod",
  "devices.done": "Gotovo",
  "devices.empty": "Još nema povezanih računara.",
  "devices.linkedBy": "Povezao/la {email}",
  "devices.linkedOn": "Povezano {date}",
  "devices.lastSeen": "Poslednji put viđen {time}",
  "devices.neverSeen": "Nikad",
  "devices.moreActions": "Još radnji za {name}",
  "devices.online": "Na vezi",
  "devices.offline": "Van veze",
  "devices.codeLastMinute": "Manje od minut. Unesite kod odmah.",
  "devices.unlink": "Raskini vezu",
  "devices.confirmUnlinkTitle": "Raskini vezu sa računarom",
  "devices.confirmUnlink":
    "Raskinuti vezu sa {name}? Desktop aplikacija će biti odspojena i njen ključ više neće važiti.",

  "tabs.slots": "Slotovi",
  "tabs.keys": "API ključevi",

  "page.notFound": "Stranica nije pronađena",
  "page.notFoundText": "Stranica koju tražite ne postoji.",
  "page.home": "Na početnu",

  "player.lockedBanner": "Vaš tonac je privremeno zaključao izmene",
  "player.invalidTitle": "Ovaj link više nije važeći",
  "player.invalidText": "Zatražite novi od svog tonca.",
  "player.photo": "Vaša fotografija",
  "player.photoAlt": "Vaša fotografija",
  "player.photoAdd": "Dodajte fotografiju",
  "player.photoReplace": "Zamenite fotografiju",
  "player.photoUploadLabel": "Otpremi fotografiju",
  "player.photoReplaceLabel": "Zameni fotografiju",
  "player.photoFile": "Datoteka fotografije",
  "player.photoLockedNote": "Fotografiju postavio vaš tonac",
  "player.photoSaved": "Fotografija je sačuvana.",
  "player.uploadingPhoto": "Otpremanje fotografije {percent}%",
  "player.consent":
    "Mogu da podelim ovu fotografiju; igrači mlađi od 16 godina treba da imaju saglasnost roditelja",
  "player.song": "Vaša pesma",
  "player.songFile": "Datoteka pesme",
  "player.songUpload": "Otpremi pesmu",
  "player.songReplace": "Zameni pesmu",
  "player.songHint": "MP3, M4A ili AAC, do 20 MB.",
  "player.consentHint": "Označite polje za saglasnost da biste otpremili fotografiju.",
  "player.songLockedNote": "Pesmu postavio vaš tonac",
  "player.songNone": "Još nema pesme. Otpremite je, pa izaberite deo (do 30 sekundi).",
  "player.songSaved": "Pesma je otpremljena.",
  "player.songTooShort": "Ova pesma je kraća od 3 sekunde.",
  "player.preparing": "Priprema datoteke…",
  "player.uploading": "Otpremanje pesme {percent}%",
  "player.waveformLoading": "Učitavanje talasnog oblika…",
  "player.waveformError": "Talasni oblik nije mogao biti učitan.",
  "player.play": "Pusti deo",
  "player.stop": "Zaustavi",
  "player.regionLength": "{seconds} sekundi",
  "player.regionSaved": "Vaš region je sačuvan. Tonac će ga dobiti pri sledećem ažuriranju.",
  "player.lockedTitle": "Zaključao tonac",
  "player.lockedExplain": "Svoj deo i dalje možete da slušate.",
  "player.invalidFull": "Ovaj link više ne radi. Zatražite novi od svog tonca.",
  "player.sectionLabel": "Vaš deo",

  "error.unknown": "Nešto nije u redu. Pokušajte ponovo.",
  "error.network_error": "Nema veze. Proverite mrežu i pokušajte ponovo.",
  "error.bad_response": "Server je poslao neočekivan odgovor.",
  "error.unknown_error": "Nešto nije u redu. Pokušajte ponovo.",
  "error.internal_error": "Greška na serveru. Pokušajte kasnije.",
  "error.http_error": "Zahtev nije mogao biti završen.",
  "error.validation_error": "Neki od unetih podataka nisu ispravni.",
  "error.not_found": "Stavka nije pronađena.",
  "error.unauthorized": "Prijavite se da biste nastavili.",
  "error.forbidden": "Nemate dozvolu za ovo.",
  "error.csrf_origin": "Zahtev je došao sa druge stranice i odbijen je.",
  "error.access_required": "Administratorski pristup nije mogao biti potvrđen.",
  "error.rate_limited": "Previše pokušaja. Sačekajte malo pa pokušajte ponovo.",
  "error.locked": "Ovo je zaključano. Prvo otključajte konfiguraciju ili osobu.",
  "error.photo_locked": "Fotografiju je zaključao operater.",
  "error.song_locked": "Pesmu je zaključao operater.",
  "error.consent_required": "Potvrdite saglasnost pre otpremanja fotografije.",
  "error.quota_exceeded": "Kvota za ovaj radni prostor je iskorišćena.",
  "error.too_large": "Datoteka je prevelika.",
  "error.ext_not_allowed": "Ova vrsta datoteke nije dozvoljena.",
  "error.media_kind_mismatch": "Ta datoteka nije očekivanog tipa.",
  "error.checksum_mismatch": "Datoteka se ne poklapa sa kontrolnim zbirom. Pokušajte ponovo.",
  "error.size_mismatch": "Veličina otpremljene datoteke se ne poklapa. Pokušajte ponovo.",
  "error.empty_body": "Datoteka je prazna.",
  "error.length_required": "Otpremanje nema navedenu veličinu.",
  "error.duration_required": "Pesma nema navedeno trajanje.",
  "error.song_required": "Region prvo zahteva pesmu.",
  "error.region_invalid": "Region nije ispravan za ovu pesmu.",
  "error.hotkey_duplicate": "Drugi slot već koristi ovu prečicu.",
  "error.hotkey_invalid": "Ova prečica nije ispravna.",
  "error.hotkey_reserved": "Ova prečica je rezervisana za desktop aplikaciju.",
  "error.person_duplicate": "Osoba se može pojaviti samo jednom u konfiguraciji.",
  "error.person_not_found": "Osoba sa spiska više ne postoji.",
  "error.export_invalid":
    "Ova konfiguracija ne može biti izvezena u ovom stanju. Proverite slotove.",
  "error.owner_protected": "Članstvo vlasnika ne može se menjati.",
  "error.cannot_remove_self": "Ne možete ukloniti sami sebe.",
  "error.not_invited": "Ovaj nalog nema pozivnicu. Zatražite je od vlasnika.",
  "error.invite_invalid": "Pozivnica nije ispravna, istekla je ili je već iskorišćena.",
  "error.invite_email_mismatch": "Prijavite se adresom e-pošte na koju je pozivnica poslata.",
  "error.email_unverified": "Vaša Google adresa e-pošte nije potvrđena.",
  "error.oauth_not_configured": "Google prijava još nije podešena.",
  "error.oauth_state_invalid": "Prijava je istekla. Počnite ponovo.",
  "error.dev_login_forbidden": "Razvojna prijava radi samo na localhost-u.",

  "admin.nav": "Admin",
  "admin.nav.label": "Admin odeljci",
  "admin.tabs.workspaces": "Radni prostori",
  "admin.col.players": "Igrači",
  "admin.action.openDetails": "Otvori detalje",
  "admin.usage.title": "Korišćenje",
  "admin.usage.players": "Igrači",
  "admin.workspace.noMembers": "Nema članova.",
  "admin.invites.copyLink": "Kopiraj link",
  "admin.audit.filter.anyWorkspace": "Svi radni prostori",
  "admin.tabs.operators": "Operateri",
  "admin.tabs.audit": "Dnevnik revizije",
  "admin.tabs.errors": "Greške",
  "admin.search": "Pretraga",
  "admin.empty": "Ništa nije pronađeno.",
  "admin.yes": "Da",
  "admin.no": "Ne",
  "admin.quota": "{used} od {quota}",
  "admin.filter.status": "Filtriraj po statusu",
  "admin.status.all": "Svi statusi",
  "admin.status.active": "Aktivan",
  "admin.status.suspended": "Suspendovan",
  "admin.status.pending": "Na čekanju",
  "admin.status.deleted": "Obrisan",
  "admin.actor.operator": "Operater",
  "admin.actor.admin": "Admin",
  "admin.actor.player": "Igrač",
  "admin.col.name": "Naziv",
  "admin.col.owner": "Vlasnik",
  "admin.col.members": "Članovi",
  "admin.col.persons": "Osobe",
  "admin.col.configs": "Konfiguracije",
  "admin.col.storage": "Skladište",
  "admin.col.status": "Status",
  "admin.col.actions": "Radnje",
  "admin.col.email": "E-pošta",
  "admin.col.admin": "Admin",
  "admin.col.identities": "Načini prijave",
  "admin.col.workspaces": "Radni prostori i uloge",
  "admin.col.time": "Vreme",
  "admin.col.actor": "Izvršilac",
  "admin.col.action": "Radnja",
  "admin.col.workspace": "Radni prostor",
  "admin.col.target": "Meta",
  "admin.col.route": "Ruta",
  "admin.col.level": "Nivo",
  "admin.col.code": "Kod",
  "admin.col.httpStatus": "HTTP",
  "admin.col.message": "Poruka",
  "admin.workspaces.title": "Radni prostori",
  "admin.workspace.back": "Nazad na radne prostore",
  "admin.workspace.configurations": "Konfiguracije",
  "admin.workspace.noConfigurations": "Nema konfiguracija.",
  "admin.action.actAs": "Radi kao",
  "admin.action.edit": "Izmeni kvote i plan",
  "admin.action.transfer": "Prenesi vlasništvo",
  "admin.action.suspend": "Suspenduj",
  "admin.action.unsuspend": "Ukini suspenziju",
  "admin.action.changeEmail": "Promeni e-poštu",
  "admin.action.unlinkGoogle": "Odvoji Google",
  "admin.action.signInLink": "Novi link za prijavu",
  "admin.action.validate": "Proveri",
  "admin.invite.open": "Pozovi tonca",
  "admin.invite.title": "Pozovite operatera",
  "admin.invite.email": "E-pošta",
  "admin.invite.workspaceName": "Naziv radnog prostora (opciono)",
  "admin.invite.submit": "Napravi pozivnicu",
  "admin.invite.shownOnce":
    "Ovaj link se prikazuje samo jednom. Pošaljite ga odmah. Ne može se ponovo prikazati.",
  "admin.invite.done": "Gotovo",
  "admin.edit.title": "Izmena radnog prostora",
  "admin.edit.name": "Naziv",
  "admin.edit.plan": "Plan",
  "admin.edit.quotaBytes": "Kvota skladišta (bajtovi)",
  "admin.edit.quotaPersons": "Kvota osoba",
  "admin.delete.title": "Obriši radni prostor",
  "admin.delete.message": "{name} će biti sakriven za sve. Kasnije ga možete vratiti.",
  "admin.restore.title": "Vrati radni prostor",
  "admin.restore.message": "{name} će ponovo biti aktivan.",
  "admin.transfer.title": "Prenos vlasništva",
  "admin.transfer.message": "Izaberite novog vlasnika za {name}. Dosadašnji vlasnik postaje član.",
  "admin.transfer.pick": "Novi vlasnik",
  "admin.transfer.none": "Nema drugih članova za prenos.",
  "admin.operators.title": "Operateri",
  "admin.operators.changeEmail.title": "Promena e-pošte",
  "admin.operators.newEmail": "Nova e-pošta",
  "admin.operators.signIn.title": "Link za prijavu",
  "admin.operators.signIn.explain":
    "Ovaj link ponovo povezuje {email} sa postojećim nalogom. Otvaranjem se prijavljuje preko Google-a i Google nalog se vezuje za ovog operatera. Novi nalog se ne pravi.",
  "admin.operators.signIn.shownOnce": "Ovaj link se prikazuje samo jednom. Kopirajte ga odmah.",
  "admin.unlink.title": "Odvoji Google",
  "admin.unlink.message":
    "{email} se više neće prijavljivati ovim Google nalogom dok ga ponovo ne poveže.",
  "admin.audit.title": "Dnevnik revizije",
  "admin.audit.filter.workspace": "ID radnog prostora",
  "admin.audit.filter.actorKind": "Vrsta izvršioca",
  "admin.audit.filter.anyActor": "Bilo koji izvršilac",
  "admin.audit.filter.action": "Radnja",
  "admin.audit.loadMore": "Učitaj još",
  "admin.errors.title": "Nedavne greške",
  "admin.errors.filter.workspace": "ID radnog prostora",
  "admin.validate.noIssues": "Nema problema.",
  "admin.validate.count": "Pronađeno problema: {count}",
  "admin.takedown.title": "Ukloni medij po ID-u",
  "admin.takedown.mediaId": "ID medija",
  "admin.takedown.reason": "Razlog",
  "admin.takedown.submit": "Ukloni",
  "admin.takedown.done": "Medij je uklonjen.",
  "admin.takedown.confirm.title": "Ukloniti ovaj medij?",
  "admin.takedown.confirm.message":
    "Medij {id} će biti uklonjen za sve gledaoce. Proverite ID pre potvrde.",
  "landing.skip": "Pređi na sadržaj",
  "landing.nav.label": "Odeljci stranice",
  "landing.nav.how": "Kako radi",
  "landing.nav.players": "Za igrače",
  "landing.nav.guys": "Za tonske majstore",
  "landing.action.signIn": "Prijava",
  "landing.action.openApp": "Otvori aplikaciju",
  "landing.action.invite": "Zatraži poziv",
  "landing.hero.titleTop": "Tvoj gol.",
  "landing.hero.titleBottom": "Tvoja pesma.",
  "landing.request.title": "Zatraži poziv",
  "landing.request.name": "Ime",
  "landing.request.team": "Tim",
  "landing.request.email": "Imejl",
  "landing.request.message": "Poruka (opciono)",
  "landing.request.submit": "Pošalji zahtev",
  "landing.request.required": "Ovo polje je obavezno.",
  "landing.request.errorEmail": "Unesite adresu imejla, na primer ime@klub.rs.",
  "landing.request.errorValidation": "Proverite označena polja.",
  "landing.request.errorRateLimited": "Previše zahteva. Pokušajte kasnije.",
  "landing.request.errorRetry": "Zahtev nije poslat. Proverite vezu i pokušajte ponovo.",
  "landing.request.success": "Hvala — poslaćemo vam pozivnicu imejlom.",
  "landing.hero.lead":
    "Igrači biraju pesmu za gol i tačne sekunde na telefonu. Tabla tonskog majstora je pusti kad postignu gol.",
  "landing.wave.label": "Deo pesme za gol",
  "landing.wave.valuetext": "{start} do {end}",
  "landing.wave.hint": "Prevucite deo ili koristite strelice na tastaturi.",
  "landing.wave.demo": "Demo snimak",
  "landing.zone.players.title": "Odbrambena zona: igrač bira",
  "landing.zone.players.p1": "Svaki igrač dobija privatni link. Bez naloga i bez aplikacije.",
  "landing.zone.players.p2":
    "Otpremi mp3, m4a ili aac, ili WAV i FLAC (konvertuju se u pregledaču). Izaberi od 3 do 30 sekundi.",
  "landing.zone.guys.title": "Neutralna zona: tonski majstor slaže tim",
  "landing.zone.guys.p1": "Postava i konfiguracije su na jednom mestu, sa prečicom za svaku pesmu.",
  "landing.zone.guys.p2": "Zaključaj konfiguraciju pre utakmice i podeli link svakog igrača.",
  "landing.zone.goal.title": "Napadačka zona: gol",
  "landing.zone.goal.p1": "Desktop soundboard pušta deo pesme svakog igrača kada postigne gol.",
  "landing.zone.goal.p2":
    "Poveži desktop kodom. Ažuriraj povlači izmene igrača, a tvoje izmene se šalju same.",
  "landing.mock.sample": "Primer podataka",
  "landing.mock.save": "Sačuvaj",
  "landing.mock.locked": "Zaključano",
  "landing.mock.config": "Domaća utakmica",
  "landing.mock.colName": "Ime",
  "landing.mock.colSection": "Deo",
  "landing.mock.window": "Soundboard",
  "landing.mock.playing": "Svira",
  "landing.closing.title": "Spremni za start?",
  "landing.footer.terms": "Besplatno uz kvote · Samo na poziv",
  "download.hero": "Preuzmite desktop aplikaciju",
  "download.meta": "macOS i Windows · {size} MB · v{version}",
  "download.compact": "Desktop aplikacija",
  "download.howToOpen": "Kako se otvara",
  "download.unsigned":
    "Još nije potpisano od strane Apple-a ili Microsoft-a: pri prvom pokretanju desni klik → Open (Mac), odnosno More info → Run anyway (Windows).",
};
